<template>
  <el-submenu :index="funcAddress">
    <div slot="title">{{ menuName }}</div>
    <template v-for="item in children">
      <template v-if="item.children">
        <draggable-sub-menu-new :funcAddress="item.funcAddress"
                                :key="item.funcAddress"
                                :menuName="item.menuName"
                                :children="item.children" />
      </template>
      <template v-else>
        <el-menu-item :key="item.funcAddress"  @click="openUrl(item.funcAddress)"
                      :index="item.funcAddress">{{ item.menuName }}</el-menu-item>
      </template>
    </template>
  </el-submenu>
</template>
<script>
export default {
  name: 'DraggableSubMenuNew',
  components: { },
  props: {
    children: { required: true, type: Array },
    funcAddress: { required: false, type: String, default: '' },
    menuName: { required: false, type: String, default: '' }
  },
  methods: {
    openUrl (url) {
      this.$store.commit('common/resetQuery', {})
      this.$router.push(url)
    }
  }
}
</script>
